export default __webpack_public_path__ + "static/media/Trash_Icon.88b12378.svg";